function t(n, r) {
  const e = r instanceof Array ? r : [r];
  if (e.includes(n.type))
    return n;
  if (!!n.parent)
    return t(n.parent, e);
}
export {
  t as getRgParentOfType
};
//# sourceMappingURL=index4.js.map
